import { Theme } from '@material-ui/core';
import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default ({ breakpoints }: Theme) =>
  createStyles({
    centerFields: {
      textAlign: 'center',
      fontSize: 12,
      '& .MuiIconButton-root': {
        padding: 0,
      },
      '& .MuiGrid-root': { justifyContent: 'center' },
    },
    switch: {
      alignItems: 'center',
      justifyContent: 'center',
      display: 'flex',
      width: '15%',
      [breakpoints.down('md')]: {
        width: '20%',
      },
      [breakpoints.down('xs')]: {
        width: '100%',
        justifyContent: 'center',
      },
    },
    textLong: {
      whiteSpace: 'nowrap',
      fontSize: 12,
      width: '45%',
    },
    actionsCell: {
      width: '10%',
      textAlign: 'center',
    },
    listAll: {
      fontSize: 12,
      whiteSpace: 'nowrap',
      margin: '0px 5px',
    },
    searchContainer: {
      alignItems: 'center',
      justifyContent: 'space-between',
      display: 'flex',
    },
    searchSize: {
      width: '83%',
      [breakpoints.down('xs')]: {
        justifyContent: 'center',
        width: '100%',
      },
    },
    filtersGrid: {
      alignItems: 'center',
      justifyContent: 'flex-end',
      display: 'flex',

      '& .MuiSelect-selectMenu': { height: 35 },
      '& .MuiOutlinedInput-root': {
        height: 35,
      },

      '& .MuiInputLabel-outlined': {
        transform: 'translate(14px, 11px) scale(1)',
        '&.MuiInputLabel-shrink': {
          transform: 'translate(14px, -6px) scale(0.75)',
        },
      },
    },
    defaultFilters: { fontSize: 12, fontWeight: 700, marginRight: 15 },
    adminFilters: { color: palette.navAdminActions },
    superAdminFilters: { color: palette.navSuperAdmin },
    operatorFilters: { color: palette.navOperatorActions },
    defaultIcon: {
      fontSize: 15,
      width: 15,
      height: 15,
      cursor: 'pointer',
      opacity: 0.5,
    },
    adminIcon: {
      backgroundColor: palette.lightNavAdminActions,
      color: palette.navAdminActions,
      borderRadius: 5,
    },
    superAdminIcon: {
      backgroundColor: palette.lightNavSuperAdminActions,
      color: palette.navSuperAdmin,
      borderRadius: 5,
    },
    operatorIcon: {
      backgroundColor: palette.lightNavOperatorActions,
      color: palette.navOperatorActions,
      borderRadius: 5,
    },
    nameField: { fontSize: 12 },
    filters: { alignItems: 'center', display: 'flex', gap: '10px' },
    refreshButton: { padding: 0, margin: 0 },
    titleMargin: { marginTop: 16 },
    buttonIsLoading: { backgroundColor: palette.borderGray },
    listButtonSize: { margin: '0px 0px 0px 8px' },
    searchButtonSize: { margin: '0px 8px 0px 8px' },
    addButton: {
      marginBottom: 8,
    },
    cloneClient: {
      '& .MuiOutlinedInput-root': {
        height: 45,
      },

      '& .MuiGrid-container': {
        alignItems: 'center',
      },
    },
    footer: {
      display: 'flex',
      justifyContent: 'flex-end',
      padding: '13px 20px',
    },
    buttonsBase: {
      borderTop: `1px solid ${palette.borderGray}`,
      justifyContent: 'right',
    },
    buttonsAlign: {
      justifyContent: 'flex-end',
      display: 'flex',
      padding: '10px 0px 5px',
    },
  });

export const overrideModalText = {
  contentText: { fontSize: '12px !important', whiteSpace: 'break-spaces' },
};
